import React from 'react';

import { useKeyValues } from '~/modules/overview-key-values/hooks/use-key-values/useKeyValues';

export interface EarningMarketCapProps {
  entityTag: string;
}

export const EarningMarketCap = ({ entityTag }: EarningMarketCapProps) => {
  const { data, isError } = useKeyValues(entityTag);

  if (!data?.length || isError) {
    return <span data-testid="error-result">-</span>;
  }

  const marketCap = data.find(item => item.key === 'market_cap.ds')?.value_fmt;

  return <span data-testid="market-cap-text">{marketCap || '-'}</span>;
};
